import { render } from "./View.vue?vue&type=template&id=3ff8aefd&scoped=true"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./View.vue?vue&type=style&index=1&id=3ff8aefd&scoped=true&lang=css"

import exportComponent from "/Users/hank/winho/gx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ff8aefd"]])

export default __exports__